const ModalMixin = {
  data () {
    return {
      isModalShow: false,
      preventClose: false
    }
  },
  methods: {
    onShowModal () {
      this.isModalShow = true
      this.toggleClasses()
    },
    onCloseModal () {
      if (!this.preventClose) {
        this.isModalShow = false
        this.toggleClasses()
      }
    },
    togglePreventCloseModal (value = false) {
      this.preventClose = value
    },
    toggleClasses () {
      if (document.querySelector('#portletFoot')) {
        document.querySelector('#portletFoot').classList.toggle('sticky-bottom')
      }
      if (document.querySelector('#portletFoot button')) {
        document.querySelector('#portletFoot button').classList.toggle('invisible')
      }
    }
  }
}

export default ModalMixin
